import Service from "./Service"

class RoleService extends Service {

    findAll = () => this.get("/roles")

    getCurrentPermissions = () => this.get("/roles/permissions/current")

    updateMatrix = (request) => this.patch("/roles", request)
}

const roleService = new RoleService()
export default roleService